import { createSlice } from '@reduxjs/toolkit';
import { TableState } from '../../components/table/model';

const initialState: TableState = {
  columns: [],
};

const targettypeListSlice = createSlice({
  name: 'targettypeTable',
  initialState,
  reducers: {
    hideColumn(state) {},
  },
});

export const targettypesReducer = targettypeListSlice.reducer;
